import { MutableRefObject, useEffect, useState } from 'react';

/**
 * Hook to indicate whether element is hovered or not.
 *
 * @param ref - reference to the DOM element that should be handled
 * @returns true if element is hovered, false otherwise
 */
export const useHover = <T extends HTMLElement>(ref: MutableRefObject<T | null>): boolean => {
    const [value, setValue] = useState<boolean>(false);

    const handleMouseOver = () => setValue(true);

    const handleMouseOut = () => setValue(false);

    useEffect(() => {
        const node = ref.current;

        if (!node) {
            return;
        }

        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);

        return () => {
            node.removeEventListener('mouseover', handleMouseOver);
            node.removeEventListener('mouseout', handleMouseOut);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current]);

    return value;
};
